"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HLQATasksFilterFields = void 0;
var HLQATasksFilterFields;
(function (HLQATasksFilterFields) {
    HLQATasksFilterFields["Status"] = "status";
    HLQATasksFilterFields["EscalationReason"] = "escalationReason";
    HLQATasksFilterFields["Priority"] = "priority";
    HLQATasksFilterFields["L1NodeTitle"] = "l1NodeTitle";
    HLQATasksFilterFields["Task"] = "task";
    HLQATasksFilterFields["TerminalNode"] = "nodeTitle";
    HLQATasksFilterFields["Attribute"] = "label";
    HLQATasksFilterFields["TotalProducts"] = "totalProducts";
    HLQATasksFilterFields["AssignedTo"] = "assignedTo";
    HLQATasksFilterFields["ReviewedBy"] = "reviewedBy";
    HLQATasksFilterFields["ProductsReviewed"] = "productsReviewed";
    HLQATasksFilterFields["PercentReviewed"] = "percentReviewed";
    HLQATasksFilterFields["TaskCount"] = "taskCount";
    HLQATasksFilterFields["InstructionsUpdatedAt"] = "instructionsUpdatedAt";
    HLQATasksFilterFields["LastReviewedAt"] = "lastReviewedAt";
    HLQATasksFilterFields["CorrectionsCount"] = "correctionEventsCount";
    HLQATasksFilterFields["CorrectionsPercentage"] = "correctionsPercent";
    HLQATasksFilterFields["TotalCorrectionsPercentage"] = "totalCorrectionsPercent";
    HLQATasksFilterFields["NotApplicable"] = "notApplicable";
    HLQATasksFilterFields["Unknown"] = "unknown";
})(HLQATasksFilterFields || (exports.HLQATasksFilterFields = HLQATasksFilterFields = {}));
